import { LitElement, html, css, unsafeCSS } from 'lit-element';
import WebMidi from 'webmidi';
import numToWords from 'number-to-words';
import colorConvert from 'color-convert';

import { scale, logScale } from './utils';

const colorOptions = {
  system: 'cmyk',
  values: [100, 100, 'variable', 0],
};

class MidiIn extends LitElement {
  static get properties() {
    return {
      source: { type: String },
      orientation: { type: String },
      backgroundColor: { type: String },
      noteColor: { type: String },
      width: { type: String },
      height: { type: String },
      left: { type: String },
      top: { type: String },
      offset: { type: Number },
      opacity: { type: Number },
      fill: { type: Boolean },
      lowNote: { type: Number },
      highNote: { type: Number },
      colorSystem: { type: String },
      colorValues: { type: Array },
      mixBlendMode: { type: String },
    };
  }

  constructor() {
    super();

    this.source = 'IAC Driver Bus 2';
    this.container = null;
    this.noteColor = null;
    this.orientation = 'vertical';
    this.width = '100%';
    this.height = '100%';
    this.colorOptions = {};
    this.offset = 0;
    this.fill = false;
    this.lowNote = 21;
    this.highNote = 108;
    this.colorValues = [0, 'variable', 0, 0];
    this.mixBlendMode = 'normal';

    WebMidi.enable((error) => {
      if (error) {
        console.log(error);
      } else {
        const IACBus1 = WebMidi.getInputByName(this.source);
        IACBus1.addListener('noteon', 'all', this.handleNoteOn.bind(this));
        IACBus1.addListener('noteoff', 'all', this.handleNoteOff.bind(this));
      }
    });
  }

  handleNoteOn(e) {
    this.container = this.shadowRoot.querySelector('#container');
    const element = document.createElement('div');
    element.id = `note${e.note.number}`;
    // write general style function
    element.style = this.getNoteStyle(e.note);

    this.container.appendChild(element);
  }

  handleNoteOff(e) {
    const element = this.shadowRoot.querySelector(`#note${e.note.number}`);

    if (element) {
      this.container.removeChild(element);
    } else {
      console.log(numToWords.toWords(e.note.number));
    }
  }

  getResponsiveColor(note) {
    const responsiveColor = this.colorValues.map((val) => {
      if (val === -1) {
        if (this.colorSystem === 'cmyk') {
          return Math.floor(
            scale(note.number, this.lowNote, this.highNote, 0, 100)
          );
        }
        if (this.colorSystem === 'lab') {
          return Math.floor(
            scale(note.number, this.lowNote, this.highNote, 0, 100)
          );
        }
      } else {
        return val;
      }
    });
    return responsiveColor;
  }

  getRGBColor(responsiveColor) {
    const system = this.colorSystem;
    let rgbColor = '';

    if (system === 'cmyk') {
      rgbColor = colorConvert.cmyk.rgb(responsiveColor);
    }
    if (system === 'lab') {
      rgbColor = colorConvert.lab.rgb(responsiveColor);
      console.log(`lab: ${responsiveColor}` + `rgb: ${rgbColor}`);
    }
    return rgbColor;
  }

  getNoteColor(note) {
    if (!note) {
      return;
    }
    let color = '';
    let rgb = '';
    const responsiveColor = this.getResponsiveColor(note);

    rgb = this.getRGBColor(responsiveColor);
    color = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
    return color;
  }

  getNoteStyle(note) {
    let style = ``;
    const containerTop = this.container.getBoundingClientRect().top;
    const containerBottom = this.container.getBoundingClientRect().top;

    const containerLeft = this.container.getBoundingClientRect().left;
    const containerHeight = window
      .getComputedStyle(this.container)
      .height.slice(0, -2);
    const containerWidth = window
      .getComputedStyle(this.container)
      .width.slice(0, -2);

    if (this.orientation === 'vertical') {
      const posOffset = scale(
        note.number - this.offset,
        this.lowNote,
        this.highNote,
        0,
        containerHeight
      );

      style = `
      position: absolute;
      bottom: ${this.fill ? 0 : posOffset}px;
      width: ${containerWidth};
      height: ${
        this.fill
          ? containerHeight
          : containerHeight / (this.highNote - this.lowNote)
      };
      background: ${this.getNoteColor(note)};
      mix-blend-mode: ${this.mixBlendMode};
    `;
    }

    if (this.orientation === 'horizontal') {
      console.log(note.number);
      const posOffset = scale(
        note.number - this.offset,
        this.lowNote,
        this.highNote,
        0,
        containerWidth
      );

      style = `
      display: inline-block;
      position: absolute;
      left: ${this.fill ? 0 : posOffset}px;
      width: ${
        this.fill
          ? containerWidth
          : containerWidth / (this.highNote - this.lowNote)
      };
      height: ${containerHeight};
      background: ${this.getNoteColor(note)};
      mix-blend-mode: ${this.mixBlendMode};



      `;
    }
    return style;
  }

  render() {
    if (WebMidi.supported) {
      return html`
        <style>
          :host {
            display: block;
          }
          #container {
            position: absolute;
            z-index: 1;
            display: block;
            width: ${this.width};
            height: ${this.height};
            left: ${this.left};
            top: ${this.top};
            background: linear-gradient(blue 10%, yellow 90%),
              ${this.backgroundColor};
            opacity: ${this.opacity};
          }
        </style>
        <div id="container"></div>
      `;
    } else {
      return html``;
    }
  }
}

customElements.define('midi-in', MidiIn);
